import React from 'react';
import ReactDOM from 'react-dom/client';

import ThemeContextProvider from './contexts/theme-context';
import './index.css';
import './accents.css';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import './utils/installPrompt';
import App from './app';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeContextProvider>
    <App />
  </ThemeContextProvider>
);

reportWebVitals();
registerServiceWorker();
